/* eslint-disable id-length */
/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import UseAxios from '../../../Api/http/http';
import {
  MenuItem,
  Select,
  IconButton,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ReactComponent as ArrowDropDown } from '../../../Assets/images/svg/drop-down-arrow.svg';
import QuarterTarget from './quarterTarget';
import { AuthContext } from '../../../Contexts/AuthContext';
import './targetSetter.scss';
import ButtonComponent from '../../../Components/Button/button';
import CircularProgressBar from '../../../Components/CircularProgressbar/circularProgressbar';
import {
  CANCEL_TEXT,
  EDIT_TARGET,
  NO,
  SAVE,
  SET_TARGET,
  UPDATE,
  YES,
} from '../../../Constants/strings';
import { deleteTargetData, getTargets } from '../../../Api/request/target';
import FormDialog from '../../../Components/Modal/modal';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider'; // Import the useSnackbar hook
import * as setTargetUtils from './setTargetUtils';
import { useNavigate } from 'react-router-dom';
import CheckConnection from '../../../Components/NetworkProvider/detectOffline';

const TargetSetter = ({ isEdit }) => {
  const { snackbarOpen } = useSnackbar(); // Destructure snackbarOpen from the useSnackbar hook
  const navigate = useNavigate();
  const { userProfile } = useContext(AuthContext);
  const [targetSetYears, setTargetSetYears] = useState([]);
  const [addYearDropdown, setAddYearDropdown] = useState([]);
  const yearDropDown = isEdit ? targetSetYears : addYearDropdown;
  const [selectedYear, setSelectedYear] = useState(
    yearDropDown.length > 0 ? yearDropDown[0] : '',
  );
  const [selectedVertical, setSelectedVertical] = useState([]); // Initialize selectedVertical state
  const [verticals, setVerticals] = useState([]);
  const [allTargets, setAllTargets] = useState({});
  const [certifications, setCertifications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [isNavigateModalOpen, setIsNavigateModalOpen] = useState(false);
  const [isYearChangeModalOpen, setIsYearChangeModalOpen] = useState(false);
  const [pendingYear, setPendingYear] = useState(null);
  const [toDelete, setToDelete] = useState([]); // State to track targets marked for deletion
  const [totalSetTarget, setTotalSetTarget] = useState(0); // State for total set target
  const [totalQuarterSetTargets, setTotalQuarterSetTargets] = useState({}); // State for total quarter set targets
  const [totalAchieved, setTotalAchieved] = useState(0);
  const [totalQuarterAchieved, setTotalQuarterAchieved] = useState({});
  const [totalQuarterPending, setTotalQuarterPending] = useState({});
  const [updatedTargets, setUpdatedTargets] = useState({});
  const [popState, setPopState] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  let deleteResponse = null;
  const targetSetterRef = useRef(null); // Ref for detecting clicks outside TargetSetter
  const [isConnectionCheck, setIsConnectionCheck] = useState(true);
  const [sortedVerticals, setSortedVerticals] = useState([]);

  useEffect(() => {
    const handleClickOutsideHandler = (
      event, // Function to handle clicks outside the component
    ) =>
      setTargetUtils.handleClickOutside(
        event,
        targetSetterRef,
        isDirty,
        setIsNavigateModalOpen,
      );
    document.addEventListener('mousedown', handleClickOutsideHandler); // Add event listener when component mounts

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideHandler); // Clean up event listener when component unmounts
    };
  }, [isDirty]);

  useEffect(() => {
    const loadData = () => {
      const storedTargetSetYears = localStorage.getItem('targetSetYears'); // Load data from localStorage
      const storedAddYearDropdown = localStorage.getItem('addYearDropdown');
      if (storedTargetSetYears) {
        setTargetSetYears(JSON.parse(storedTargetSetYears));
      }
      if (storedAddYearDropdown) {
        setAddYearDropdown(JSON.parse(storedAddYearDropdown));
      }
    };

    loadData();
  }, []);
  useEffect(() => {
    if (yearDropDown.length > 0) {
      setSelectedYear(yearDropDown[0]);
    }
  }, [yearDropDown]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const certs = await setTargetUtils.fetchCertifications(snackbarOpen); // Fetch data when the component mounts
        setCertifications(certs);
        const verts = await setTargetUtils.fetchVerticals();
        setVerticals(verts);
        const response = selectedYear ? await UseAxios(getTargets(selectedYear)) : null;
        const result = response?.data;
        if (selectedYear === '') {
          return;
        }
        if (result?.response && result?.response?.data?.statusCode === 441) {
          setTotalSetTarget(0);
          setTotalAchieved(0);
          setTotalQuarterSetTargets({});
          setTotalQuarterAchieved({});
          setTotalQuarterPending({});
          const initialTargets = setTargetUtils.createInitialTargets(verts);
          setAllTargets(initialTargets);
          setSelectedVertical(sortedVerticals[0]?.name); // Select the first vertical by default
        } else if (result) {
          const getTargetData = result;
          setTotalSetTarget(result.totalTargetsCount[0].totalSetTarget); // Set the total set target
          setTotalQuarterSetTargets(result.totalSetTargets[0]); // Set the total quarter set targets
          setTotalAchieved(result.totalTargetsCount[0].totalAchieved);
          setTotalQuarterAchieved(result.totalAchievedTargets[0]);
          setTotalQuarterPending(result.totalPendingTargets[0]);
          const initialTargets = setTargetUtils.createInitialTargets(verts);
          if (isEdit) {
            const targets = getTargetData.targetDetails;
            setTargetUtils.populateInitialTargets(
              targets,
              initialTargets,
              certs,
              verts,
            );
          }
          setAllTargets(initialTargets);
          setSelectedVertical(sortedVerticals[0]?.name); // Select the first vertical by default
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        snackbarOpen(`${SET_TARGET.OOPS_TRY_AGAIN}`, 'warning');
      }
    };
    if (isConnectionCheck) {
      fetchData();
    }
  }, [selectedYear, isEdit]);

  useEffect(() => {
    if (verticals.length > 0) {
      const sortedVerts = [...verticals].sort((a, b) => {
        const countA = countTargetsForVertical(a.name);
        const countB = countTargetsForVertical(b.name);
        return countB - countA;
      });
      setSortedVerticals(sortedVerts);
      if (!selectedVertical) {
        setSelectedVertical(sortedVerts[0]?.name); // Select the first vertical by default
      }
    }
  }, [verticals, allTargets]);


  const countTargetsForVertical = (verticalName) => {
    if (!allTargets || !verticals) {
      return 0;
    }
    const vertical = verticals.find((verts) => verts.name === verticalName);
    if (!vertical) {
      return 0;
    }
    return (
      allTargets[vertical.name]?.reduce((total, quarter) => {
        return (
          total + quarter.targets.reduce((quarterTotal, target) => {
            return quarterTotal + (target.targetDetails?.currentQuarterTarget || 0);
          }, 0)
        );
      }, 0) || 0
    );
  };

  const handleConnectionCheck = (online) => {
    setIsConnectionCheck(online);
  };

  useEffect(() => {
    // Handle beforeunload event with a slightly different implementation
    const handleBeforeUnloadHandler = function (event) {
      return setTargetUtils.handleBeforeUnload(event, isDirty);
    };
    window.addEventListener('beforeunload', handleBeforeUnloadHandler);
    return function cleanup() {
      window.removeEventListener('beforeunload', handleBeforeUnloadHandler);
    };
  }, [isDirty]);


  useEffect(() => {
    // Handle popstate event specifically for navigating back when dirty state is true
    if (isDirty) {
      const handlePopstate = function () {
        setPopState(true);
        setIsModalOpen(true);
      };

      history.pushState({}, document.title, window.location.pathname);
      window.addEventListener('popstate', handlePopstate);

      return function cleanupHandler() {
        window.removeEventListener('popstate', handlePopstate);
      };
    }
  }, [isDirty, popState]);

  useEffect(() => {
    calculateQuarterTargets();
  }, [allTargets, verticals]);

  const calculateQuarterTargets = () => {
    // Calculate quarter-wise targets across all verticals
    const totCalculation = setTargetUtils.calculateQuarterCount(
      verticals,
      allTargets,
    );
    setTotalQuarterSetTargets(totCalculation.quarterTargetsAccumulator);
    setTotalSetTarget(totCalculation.totalSetTarget);
  };

  const handleTargetChange = (vert, quarterName, targets) => {
    const updatedTargetsForVert = updatedTargets[vert] || {}; // Function to handle target change event and update state
    const updatedTargetsForQuarter = targets.map((target) => ({
      ...target,
    }));
    updatedTargetsForVert[quarterName] = updatedTargetsForQuarter;
    setUpdatedTargets({
      ...updatedTargets,
      [vert]: updatedTargetsForVert,
    });
    const updatedAllTargets = allTargets[vert].map((quarter) =>
      quarter.quarter === quarterName
        ? { ...quarter, targets: updatedTargetsForQuarter }
        : quarter,
    );
    setAllTargets({ ...allTargets, [vert]: updatedAllTargets });
    setIsDirty(updatedAllTargets.some((quarter) => quarter.targets.length > 0));
  };

  const handleTabChange = (event, newValue) => {
    setSelectedVertical(newValue);
  };

  const deleteTarget = async (targetId) => {
    if (isEdit && targetId) {
      const response = await UseAxios(
        deleteTargetData(targetId, userProfile.user_name),
      );
      deleteResponse = response;
    }
  };

  const handleSave = async () => {
    setIsErrorMsg(true);
    try {
      const deleteTargets = toDelete.map((targetId) => deleteTarget(targetId)); // Process deletions first
      await Promise.all(deleteTargets);
      setToDelete([]); // Clear the toDelete array after processing
      const saveAllVerticals = verticals.map(async (vert) => {
        const verticalTargets = allTargets[vert.name];
        const params = {
          vert,
          verticalTargets,
          year: selectedYear,
          isEdit,
          certifications,
          snackbarOpen,
          navigate,
          pendingYear,
          userProfile,
          setIsErrorMsg,
        };
        await setTargetUtils.processVerticalTargets(params);
      });
      await Promise.all(saveAllVerticals);
      setIsDirty(false);
      setUpdatedTargets({}); // Clear the updatedTargets state
      if (
        deleteResponse?.data.status === 200
        || deleteResponse?.data.statusCode === 200
      ) {
        snackbarOpen(`${EDIT_TARGET.TARGET_UPDATED}`, 'success');
        if (pendingYear !== null) {
          setSelectedYear(pendingYear);
          setPendingYear(null);
          return;
        }
        navigate('/certifications/target');
      }
      if (pendingYear !== null) {
        setSelectedYear(pendingYear);
        setPendingYear(null);
        return;
      }
    } catch (error) {
      setIsErrorMsg(false);
      console.error('Error saving targets:', error);
      snackbarOpen(`${SET_TARGET.OOPS_TRY_AGAIN}`, 'warning');
    }
  };

  const handleDelete = (vert, quarterName, targetId) => {
    setToDelete((prevToDelete) => [...prevToDelete, targetId]);
    const updatedTargetValue = allTargets[vert].map((quarter) =>
      quarter.quarter === quarterName
        ? {
          ...quarter,
          targets: quarter.targets.filter(
            (target) => target.targetId !== targetId,
          ),
        }
        : quarter,
    );
    setAllTargets({ ...allTargets, [vert]: updatedTargetValue });
    setIsDirty(true);
  };

  const handleBackButtonClick = () => {
    if (isDirty) {
      setIsModalOpen(true);
    } else {
      navigate('/certifications/target');
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setPopState(false);
    setIsYearChangeModalOpen(false);
    setIsNavigateModalOpen(false);
  };

  const handleModalConfirm = () => {
    setIsModalOpen(false);
    setIsYearChangeModalOpen(false);
    navigate('/certifications/target');
  };

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    if (isDirty) {
      setPendingYear(newYear);
      setIsYearChangeModalOpen(true);
    } else {
      setSelectedYear(newYear);
    }
  };

  const handleYearChangeConfirm = () => {
    handleSave();
    setIsYearChangeModalOpen(false);
  };

  const handleNavigateModalConfirm = () => {
    handleSave();
    setIsNavigateModalOpen(false);
  };

  const handleYearChangeDiscard = () => {
    const clearedTargets = verticals.reduce((acc, vert) => {
      acc[vert.name] = setTargetUtils.initialQuarters.map((quarter) => ({
        ...quarter,
      }));
      return acc;
    }, {});
    setAllTargets(clearedTargets);
    setIsDirty(false);
    setSelectedYear(pendingYear);
    setPendingYear(null);
    setIsYearChangeModalOpen(false);
  };
  const targetPercentage = totalSetTarget
    ? (totalAchieved / totalSetTarget) * 100
    : 0;

  return (
    <div className="target-setter-parent" ref={targetSetterRef}>
      <div className="target-setter">
        <CheckConnection
          onCheck={handleConnectionCheck}
          errorMsg={SET_TARGET.OOPS_TRY_AGAIN}
        />
        <div className="target-container">
          <div className="target-title">
            <IconButton
              className="target-back-icon"
              onClick={handleBackButtonClick}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <Typography className="target-title-text">
              {isEdit
                ? EDIT_TARGET.EDIT_TARGET_TITLE
                : SET_TARGET.SET_TARGET_TITLE}
            </Typography>
          </div>
          <div className="target-year">
            <div className="target-dropdown">
              <Select
                className="target-year-select"
                value={selectedYear}
                onChange={handleYearChange}
                IconComponent={ArrowDropDown}
              >
                {yearDropDown.map((year) => (
                  <MenuItem
                    className="target-year-menu"
                    key={year}
                    value={year}
                  >
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <div className="quarter-summary">
            <div className="quarter-summary-container">
              <div className="total-target">
                <div className="target-quarter-card">
                  <Typography className="target-quarter-title">
                    {SET_TARGET.TOTAL_TARGET}
                  </Typography>
                  <div className="target-quarter-components">
                    <CircularProgressBar
                      progressBarCss="target-progress-bar"
                      value={targetPercentage}
                    />
                    <Typography className="total-target-count">
                      {totalSetTarget}
                    </Typography>
                  </div>
                </div>
              </div>
              {allTargets[selectedVertical]?.map((quarter) => {
                const quarterPercentage = totalQuarterSetTargets[
                  `quarter${quarter.quarter}`
                ]
                  ? ((totalQuarterAchieved[`quarter${quarter.quarter}`]
                      - totalQuarterPending[
                        `quarter${quarter.quarter}`
                      ])
                      / totalQuarterSetTargets[`quarter${quarter.quarter}`])
                    * 100
                  : 0;

                return (
                  <div
                    className="target-quarter-card-container"
                    key={quarter.quarter}
                  >
                    <div className="target-quarter-card">
                      <Typography className="target-quarter-title">
                        {EDIT_TARGET.TARGET_QUARTER} {quarter.quarter}
                      </Typography>
                      <div className="target-quarter-components">
                        <CircularProgressBar value={quarterPercentage} />
                        <Typography className="quarter-count">
                          {totalQuarterSetTargets[
                            `quarter${quarter.quarter}`
                          ] || 0}
                        </Typography>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="target-tabs">
            <Tabs
              value={selectedVertical}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              {sortedVerticals.map((vert) => (
                <Tab key={vert.id} label={vert.name} value={vert.name} />
              ))}
            </Tabs>
          </div>
          <div className="quarter-target-div">
            {allTargets[selectedVertical]?.map((quarter) => (
              <QuarterTarget
                key={quarter.quarter}
                quarter={quarter.quarter}
                targets={quarter.targets}
                onTargetChange={(targets) =>
                  handleTargetChange(selectedVertical, quarter.quarter, targets)
                }
                onDeleteTarget={(targetId) =>
                  handleDelete(selectedVertical, quarter.quarter, targetId)
                }
                isEdit={isEdit}
                year={selectedYear}
                setIsDirty={setIsDirty}
                setIsErrorMsg={setIsErrorMsg}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="target-set-save">
        <ButtonComponent
          btnCss={isErrorMsg ? 'set-save-disabled-btn' : 'target-set-save-btn'}
          label={isEdit ? UPDATE : SAVE}
          variant="contained"
          onClick={handleSave}
          disabled={isErrorMsg}
        />
      </div>
      <FormDialog
        title={EDIT_TARGET.CONFIRMATION}
        open={isModalOpen}
        handleClose={handleModalClose}
        button1Action={handleModalClose}
        button2Action={handleModalConfirm}
        dialogPaperCss="target-dialog-paper"
        dialogCss="target-dialog"
        dialogBodycontent={
          <div className="target-dialog-text">
            <span>{EDIT_TARGET.EXIT_CONFIRM}</span>
          </div>
        }
        button1={CANCEL_TEXT}
        button2={YES}
        cancelButtonId="target-cancel-btn"
        submitButtonId="target-submit-btn"
      />
      <FormDialog
        title={EDIT_TARGET.CONFIRMATION}
        open={isYearChangeModalOpen}
        handleClose={handleModalClose}
        button1Action={handleYearChangeDiscard}
        button2Action={handleYearChangeConfirm}
        dialogPaperCss="target-dialog-paper"
        dialogCss="target-dialog"
        dialogBodycontent={
          <div className="target-dialog-text">
            <span>{EDIT_TARGET.CONFIRM_SAVE_DATA}</span>
          </div>
        }
        button1={NO}
        button2={YES}
        cancelButtonId="target-cancel-btn"
        submitButtonId="target-submit-btn"
      />
      <FormDialog
        title={EDIT_TARGET.CONFIRMATION}
        open={isNavigateModalOpen}
        handleClose={handleModalClose}
        button1Action={handleModalClose}
        button2Action={handleNavigateModalConfirm}
        dialogPaperCss="target-dialog-paper"
        dialogCss="target-dialog"
        dialogBodycontent={
          <div className="target-dialog-text">
            <span>{EDIT_TARGET.CONFIRM_SAVE_TARGET}</span>
          </div>
        }
        button1={CANCEL_TEXT}
        button2={SAVE}
      />
    </div>
  );
};

TargetSetter.propTypes = {
  isEdit: PropTypes.bool,
};

export default TargetSetter;
